<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between">
      <div>
        <div class="section-title">{{ $tc("Stock Variance Reasons", 2) }}</div>
        <div class="section-subTitle my-2">{{ $t("reasons_dash_msg") }}</div>
      </div>
      <div v-if="$can('create', 'Stock Variance Reasons')">
        <b-button
          variant="default"
          to="edit-stocktakereasons"
          class="btn-blue"
          >{{ $tc("add") }}</b-button
        >
      </div>
    </div>

    <div class="d-flex justify-content-between align-items-center my-3">
      <div>
        <b-form-input
          v-debounce:300="getStockReasonData"
          v-model="searchValue"
          placeholder="Search..."
        ></b-form-input>
      </div>

      <div class="dropdown-curve-container ml-2">
        <b-dropdown
          :text="selectedStatusName"
          variant="dropdown-curve"
          style="width: 200px"
        >
          <b-dropdown-item
            v-for="(dropdownItem, dropdownIndex) in ActiveInactivefilterGroup"
            :key="dropdownIndex"
            href="#"
            @click="onStatusChange(dropdownItem)"
            >{{ dropdownItem.name }}</b-dropdown-item
          >
        </b-dropdown>
      </div>

      <div class="d-flex align-items-center">
        <div class="mx-2">
          <b-dropdown name="listview" id="listview" variant="outline-blue">
            <template v-slot:button-content>
              <!-- Viewing &nbsp;
              <strong>{{ selectedvalue }}</strong>
              &nbsp;Of&nbsp; -->
              <strong>{{ viewingRange }}</strong>
            </template>
            <b-dropdown-item
              v-for="(list, listIndex) in viewingnumbers"
              :key="listIndex"
              @click="onDropDownChangeValue(list.name)"
              >{{ list.name }}</b-dropdown-item
            >
          </b-dropdown>
        </div>
      </div>
    </div>

    <table class="list-view-table">
      <thead>
        <tr>
          <th class="text-left" style="width: 120px">
            <span class="pr-3">{{ $tc("status", 2) }}</span>
          </th>
          <th>
            <!-- <img
              v-if="this.columnName != 'territory_name'"
              @click="onSortValue('territory_name', 'asc')"
              src="@/assets/img/icons/updown.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else-if="isSort && isAscending"
              @click="onSortValue('territory_name', 'asc')"
              src="@/assets/img/icons/asc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else
              @click="onSortValue('territory_name', 'desc')"
              src="@/assets/img/icons/desc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            /> -->
            {{ $tc("Reason", 1) }}
          </th>
        </tr>
      </thead>
      <tbody v-if="StockReasonData.length > 0">
        <tr v-for="(item, key) in StockReasonData" :key="key">
          <td>
            <div class="d-flex align-items-center justify-content-start">
              <StatusDot
                :status="item.reason_is_active == 'Y' ? 'active' : 'inactive'"
              />
              <!--  -->
              <div
                v-if="$can('update', 'Stock Variance Reasons')"
                class="ml-4 clickable-icon"
                @click="goToRoute('/fnb/edit-stocktakereasons', item)"
                v-b-tooltip="'Edit'"
                tabindex="0"
                style="cursor: pointer"
              >
                <i class="edit-pen icon blue-icon"></i>
              </div>
            </div>
          </td>

          <td>{{ $tc(item.reason_name, 1) }}</td>
        </tr>
      </tbody>
      <tbody v-if="StockReasonData.length == 0">
        <tr>
          <td colspan="2">
            <div class="h6 my-3 text-center">{{ $t("NoRecords") }}</div>
          </td>
        </tr>
      </tbody>
    </table>
    <b-pagination
      v-if="StockReasonData.length > 0"
      v-model="currentPage"
      :total-rows="rows"
      @change="onChangePagination($event)"
      :per-page="perPage"
      aria-controls="my-table"
    ></b-pagination>
  </div>
</template>

<script>
  import MasterService from "@/services/MasterService";
  import StatusDot from "@/components/Partials/StatusDot.vue";
  import FilterByStatusDropdown from "@/components/Partials/FilterByStatusDropdown.vue";
  import ExhibitorService from "@/services/ExhibitorService";
  export default {
    components: {
      StatusDot,
      FilterByStatusDropdown,
    },
    data() {
      return {
        perPage: 10,
        currentPage: 1,
        rows: 0,
        selectedvalue: "10",
        StockReasonData: [],

        viewingnumbers: [],
        customErrors: {
          message: "",
        },
        selectedStatusName: "Active",
        selectedStatus: "Y",
        ActiveInactivefilterGroup: [
          {
            name: "All",
            is_active: "",
          },
          {
            name: "Active",
            is_active: "Y",
          },
          {
            name: "InActive",
            is_active: "N",
          },
        ],
        orderby: "",
        columnName: "",

        debounce: null,
        searchValue: "",
        searchKey: "reason_name",
      };
    },
    computed: {
      viewingRange() {
        if (this.rows === 0) {
          return "Viewing 0 to 0 of 0";
        }

        const start = (this.currentPage - 1) * this.perPage + 1;
        const end = Math.min(this.currentPage * this.perPage, this.rows);

        return `Viewing ${start} to ${end} of ${this.rows}`;
      },
    },

    beforeMount() {
      this.getStockReasonData();
      this.getviewingnumber();
    },
    methods: {
      getviewingnumber() {
        this.viewingnumbers = [
          { name: "All", id: 1 },
          { name: "10", id: 2 },
          { name: "20", id: 3 },
          { name: "30", id: 3 },
          { name: "40", id: 4 },
          { name: "50", id: 5 },
        ];
      },
      onStatusChange: function(value) {
        this.Screens = this.ScreensCopy;
        this.selectedStatusName = value.name;
        this.selectedStatus = value.is_active;
        this.getStockReasonData();
      },
      onDropDownChangeValue(event) {
        if (event == "All") {
          this.perPage = this.rows;
          this.selectedvalue = event;
          this.onChangePagination();
        } else {
          this.selectedvalue = event;
          this.perPage = event;
          this.onChangePagination();
        }
      },

      /* eslint-disable */
      onChangePagination: function(event) {
        if (event === undefined) {
          this.currentPage = 1;
          this.getStockReasonData();
        } else {
          this.currentPage = event;
          this.getStockReasonData();
        }
      },

      goToRoute: function(path, item) {
        const { reason_id } = item;
        this.$router.push({
          path: path,
          query: {
            reason_id: reason_id,
          },
        });
      },
      //Sort
      // onSortValue(columnName, orderby) {
      //   this.isSort = true;
      //   this.isAscending = !this.isAscending;
      //   this.columnName = columnName;
      //   this.orderby = orderby;
      //   this.getStatesList();
      // },

      getStockReasonData() {
        // this.pp_type_id = item.pp_type_id;
        // this.is_active = item.is_active;
        let payload = {
          searchValue: this.searchValue,
          reason_is_active: this.selectedStatus,
          // pp_type_id: this.pp_type_id,
          // is_active: this.is_active,
        };
        ExhibitorService.GetStockReasonData(payload)
          .then((response) => {
            const { data } = response;
            if (data.totalRows >= 10) {
              this.rows = data.totalRows;
            } else {
              this.rows = data.totalRows;
              this.selectedvalue = data.totalRows;
            }
            if (data.Records.length > 0) {
              // console.log(data.Records);
              let StockReasonData = data.Records;
              this.StockReasonData = StockReasonData;
            } else {
              this.StockReasonData = [];
            }
          })
          .catch((error) => {
            console.log(error);
          });
      },

      viewType: function(viewType) {
        if (viewType == "gridView") {
          this.gridView = true;
          this.listView = false;
        } else if ((viewType = "listView")) {
          this.listView = true;
          this.gridView = false;
        }
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/Pages/FoodAndBeveragesContainer/StockComponents/stocktakereasons.vue